export default __webpack_public_path__ + "static/media/cup.d2435d58.jpg";